function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#00A783",
  width: 45,
  height: 45,
  rx: 22.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 8C30.508 8 37 14.492 37 22.5c0 7.501-5.696 13.672-13 14.423v1.87a.5.5 0 01-.854.353l-2.792-2.792a.5.5 0 010-.708l2.792-2.792a.5.5 0 01.854.353v1.834c6.268-.742 11.129-6.074 11.129-12.541 0-6.975-5.654-12.629-12.629-12.629S9.871 15.525 9.871 22.5A.935.935 0 118 22.5C8 14.492 14.492 8 22.5 8z",
  fill: "#FFF",
  opacity: 0.6
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.545 18.4a.81.81 0 00-.818-.8h-2.454a.81.81 0 00-.818.8v2.4h-1.637v-2.4c0-1.325 1.1-2.4 2.455-2.4h2.454c1.356 0 2.455 1.075 2.455 2.4v2.4H27V28h-9v-7.2h6.545v-2.4z",
  fill: "#FFF"
}));

function SvgIconUpdatePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdatePassword);
export default __webpack_public_path__ + "static/media/icon-update-password.136a0f8c.svg";
export { ForwardRef as ReactComponent };